<template>
  <div>
    <div id="bilanco-detay">
      <table class="table is-fullwidth is-striped">
        <tr v-for="item in data" v-bind:key="item.id">
          <td v-for="it in item" v-bind:key="it.id">{{ it }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import iconv from "iconv-lite";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["symbol"])
  },
  data: function() {
    return {
      data: []
    };
  },
  mounted: function() {
    axios
      .get(
        process.env.VUE_APP_PROXY +
        "cmd=BilancoDetay?symbol=" +
          this.symbol +
          "?konsolide=0" +
          "?lang=" +
          this.$i18n.locale,
        { responseType: "arraybuffer", responseEncoding: "binary" }
      )
      .then(response => this.parseResponse(response));
  },
  methods: {
    parseResponse: function(response) {
      let data = iconv.decode(Buffer.from(response.data), "ISO-8859-9");
      let rows = data.split("\n");
      rows.forEach(row => {
        this.data.push(row.split(";"));
      });
    }
  }
};
</script>